<!--
    this components allows to display a search result:
    - a profile card
    - a button if profile is pending
    - a divider for mobile version only

    <SearchProfileCard
        user="..."  # MANDATORY : user data to display
    />
 -->
<script setup lang="ts">
/* UTILS */
import { useCssBreakpoints, ALIconButton } from '@af-lib/vue-ui';
/* COMPOSABLE */
import { usePostSendWorkflowReminder } from '@/api/vue-query/users/users.mutations';
/* COMPONENTS */
import ProfileCard from '@/components/profileCard/ProfileCard.vue';
import { ref } from 'vue';
/* STORES */
import { useAuthStore } from '@/stores/auth';
/* TYPES */
import type { UserSearch } from '@/types/api/user/user';

/* TYPES */

type Props = {
  user: UserSearch;
};

const props = defineProps<Props>();
const profileCardElement = ref();
const authStore = useAuthStore();

const { isMobile } = useCssBreakpoints();

const { isPending: isLoadingSendReminder, mutate: sendInviteReminder } = usePostSendWorkflowReminder();

const isUserPending = props.user.sharepool_status === 'pending';

function redirectToProfile() {
  if (!isUserPending) {
    profileCardElement.value?.redirectToProfile();
  }
}

</script>

<template>
  <div>
    <div
    :class="['d-flex align-center justify-space-between', { 'cursor-pointer': !isUserPending }]"
    @click="redirectToProfile"
  >
      <v-hover v-slot="{ isHovering, props: hoverProps }">
       <ProfileCard
        ref="profileCardElement"
        v-bind="hoverProps"
        class="my-3 w-100 pl-1"
        :class="isHovering ? 'bg-grey-lighten-5' : ''"
        style="padding: 8px"
        :user="props.user"
        :noJob="isUserPending"
        :noEmail="isUserPending"
      />

      </v-hover>
      <ALIconButton
        v-if="isUserPending"
        variant="tertiary"
        icon="fas fa-paper-plane"
        tooltipPosition="left"
        :isLoading="isLoadingSendReminder"
        :label="$t('general.remind')"
        @click="
          sendInviteReminder({
            uuids: [props.user.user_uuid],
            candidate: props.user,
            origin: 'search',
            sourceUuid: authStore.getCompanyUuid ?? undefined
          })
        "
      />
    </div>

    <v-divider v-if="isMobile" />
  </div>
</template>
